import { useEffect, useRef } from 'react';

interface UseModalBackHandlerOptions {
  isOpen: boolean;
  onClose: () => void;
  enabled?: boolean;
}

/**
 * Modal açıkken geri tuşuna basılınca modalı kapatır
 * @param isOpen - Modal açık mı?
 * @param onClose - Modal kapatma fonksiyonu
 * @param enabled - Hook aktif mi? (varsayılan: true)
 */
export function useModalBackHandler({ isOpen, onClose, enabled = true }: UseModalBackHandlerOptions) {
  const onCloseRef = useRef(onClose);
  const enabledRef = useRef(enabled);
  const isOpenRef = useRef(isOpen);
  const hasAddedHistoryEntry = useRef(false);

  useEffect(() => {
    onCloseRef.current = onClose;
    enabledRef.current = enabled;
    isOpenRef.current = isOpen;
  });

  useEffect(() => {
    if (!enabled) return;
    
    if (isOpen && !hasAddedHistoryEntry.current) {
      //window.history.pushState({ modal: true }, '', window.location.href);
      hasAddedHistoryEntry.current = true;
    } else if (!isOpen && hasAddedHistoryEntry.current) {
      hasAddedHistoryEntry.current = false;
    }
  }, [isOpen, enabled]);

  useEffect(() => {
    if (!enabled || !isOpen) return;
    
    const handlePopState = (event: PopStateEvent) => {
      if (isOpenRef.current && enabledRef.current) {
        onCloseRef.current();
      }
    };
    
    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isOpen, enabled]);
}
